/**
 * Internal dependencies
 */
import SVGStackableIconTextured from './images/stackable-icon-textured.svg'
import SVGAccordionIcon from './images/accordion-icon.svg'
import SVGBlockquoteIcon from './images/blockquote-icon.svg'
import SVGBlogPostsIcon from './images/blog-posts-icon.svg'
import SVGButtonGroupIcon from './images/button-group-icon.svg'
import SVGButtonIcon from './images/button-icon.svg'
import SVGCardIcon from './images/card-icon.svg'
import SVGColumnsIcon from './images/columns-icon.svg'
import SVGColumnIcon from './images/column-icon.svg'
import SVGContainerIcon from './images/container-icon.svg'
import SVGCountUpIcon from './images/count-up-icon.svg'
import SVGCTAIcon from './images/cta-icon.svg'
import SVGDividerIcon from './images/divider-icon.svg'
import SVGExpandIcon from './images/expand-icon.svg'
import SVGFeatureGridIcon from './images/feature-grid-icon.svg'
import SVGFeatureIcon from './images/feature-icon.svg'
import SVGHeroIcon from './images/hero-icon.svg'
import SVGHeadingIcon from './images/heading-icon.svg'
import SVGIconIcon from './images/icon-icon.svg'
import SVGIconButtonIcon from './images/icon-button-icon.svg'
import SVGIconButtonsIcon from './images/icon-buttons.svg'
import SVGIconBoxIcon from './images/icon-box-icon.svg'
import SVGIconListIcon from './images/icon-list-icon.svg'
import SVGIconLabelIcon from './images/icon-label-icon.svg'
import SVGImageIcon from './images/image-icon.svg'
import SVGImageBoxIcon from './images/image-box-icon.svg'
import SVGLoadMoreIcon from './images/load-more.svg'
import SVGNotificationIcon from './images/notification-icon.svg'
import SVGNumberBoxIcon from './images/number-box-icon.svg'
import SVGPaginationIcon from './images/pagination.svg'
import SVGPricingBoxIcon from './images/pricing-box-icon.svg'
import SVGSeparatorIcon from './images/separator-icon.svg'
import SVGSocialButtonsIcon from './images/social-buttons.svg'
import SVGSpacerIcon from './images/spacer-icon.svg'
import SVGTeamMemberIcon from './images/team-member-icon.svg'
import SVGTestimonialIcon from './images/testimonial-icon.svg'
import SVGTextIcon from './images/text-icon.svg'
import SVGVideoPopupIcon from './images/video-popup-icon.svg'
import SVGUngroupContainerIcon from './images/ungroup-container-icon.svg'

/**
 * WordPress dependencies
 */
import { cloneElement, render } from '@wordpress/element'
import domReady from '@wordpress/dom-ready'

export function colorizeIcon( SvgIcon ) {
	return cloneElement( SvgIcon, {
		fill: 'url(#stackable-gradient)',
		className: `stk-stackable-icon-gradient ${ SvgIcon.props.className || '' }`,
	} )
}

// Add our SVG gradient placeholder definition that we'll reuse.
domReady( () => {
	if ( document.querySelector( 'svg.ugb-stackable-gradient' ) ) {
		return
	}

	const stackableGradient = document.createElement( 'DIV' )
	stackableGradient.setAttribute( 'style', 'height: 0; width: 0; overflow: hidden;' )
	stackableGradient.setAttribute( 'aria-hidden', 'true' )
	document.querySelector( 'body' ).appendChild( stackableGradient )
	render(
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="ugb-stackable-gradient"
			height="0"
			width="0"
			style={ { opacity: 0 } }
		>
			<defs>
				<linearGradient id="stackable-gradient">
					<stop offset="0%" stopColor="#8c33da" stopOpacity="1" />
					<stop offset="100%" stopColor="#f34957" stopOpacity="1" />
				</linearGradient>
			</defs>
		</svg>,
		stackableGradient
	)
} )

export function SVGStackableCategoryIcon() {
	return colorizeIcon( <SVGStackableIconTextured width="20" height="20" className="components-panel__icon" /> )
}

export function SVGStackableIcon( { className } ) {
	return <SVGStackableIconTextured className={ className } width="20" height="20" />
}

export function StackableIcon() {
	return colorizeIcon( <SVGStackableIconTextured width="20" height="20" /> )
}

export function AccordionIcon() {
	return colorizeIcon( <SVGAccordionIcon width="20" height="20" /> )
}

export function BlockquoteIcon() {
	return colorizeIcon( <SVGBlockquoteIcon width="20" height="20" /> )
}

export function BlogPostsIcon() {
	return colorizeIcon( <SVGBlogPostsIcon width="20" height="20" /> )
}

export function ButtonIcon() {
	return colorizeIcon( <SVGButtonIcon width="16" height="16" /> )
}

export function ButtonGroupIcon() {
	return colorizeIcon( <SVGButtonGroupIcon width="16" height="16" /> )
}

export function CardIcon() {
	return colorizeIcon( <SVGCardIcon width="20" height="20" /> )
}

export function ColumnsIcon() {
	return colorizeIcon( <SVGColumnsIcon width="20" height="20" /> )
}

export function ColumnIcon() {
	return colorizeIcon( <SVGColumnIcon width="20" height="20" /> )
}

export function ContainerIcon() {
	return colorizeIcon( <SVGContainerIcon width="20" height="20" /> )
}

export function CountUpIcon() {
	return colorizeIcon( <SVGCountUpIcon width="20" height="20" /> )
}

export function CTAIcon() {
	return colorizeIcon( <SVGCTAIcon width="20" height="20" /> )
}

export function DividerIcon() {
	return colorizeIcon( <SVGDividerIcon width="20" height="20" /> )
}

export function ExpandIcon() {
	return colorizeIcon( <SVGExpandIcon width="20" height="20" /> )
}

export function FeatureGridIcon() {
	return colorizeIcon( <SVGFeatureGridIcon width="20" height="20" /> )
}

export function FeatureIcon() {
	return colorizeIcon( <SVGFeatureIcon width="20" height="20" /> )
}

export function HeroIcon() {
	return colorizeIcon( <SVGHeroIcon width="20" height="20" /> )
}

export function HeadingIcon() {
	return colorizeIcon( <SVGHeadingIcon width="20" height="20" /> )
}

export function GroupContainerIcon() {
	return colorizeIcon( <SVGContainerIcon width="20" height="20" className="components-menu-items__item-icon" /> )
}

export function IconIcon() {
	return colorizeIcon( <SVGIconIcon width="20" height="20" /> )
}

export function IconButtonIcon() {
	return colorizeIcon( <SVGIconButtonIcon width="16" height="16" /> )
}

export function IconButtonsIcon() {
	return colorizeIcon( <SVGIconButtonsIcon width="16" height="16" /> )
}

export function IconBoxIcon() {
	return colorizeIcon( <SVGIconBoxIcon width="16" height="16" /> )
}

export function IconListIcon() {
	return colorizeIcon( <SVGIconListIcon width="20" height="20" /> )
}

export function IconLabelIcon() {
	return colorizeIcon( <SVGIconLabelIcon width="16" height="16" /> )
}

export function ImageIcon() {
	return colorizeIcon( <SVGImageIcon width="20" height="20" /> )
}

export function ImageBoxIcon() {
	return colorizeIcon( <SVGImageBoxIcon width="20" height="20" /> )
}

export function LoadMoreIcon() {
	return colorizeIcon( <SVGLoadMoreIcon width="16" height="16" /> )
}

export function NotificationIcon() {
	return colorizeIcon( <SVGNotificationIcon width="20" height="20" /> )
}

export function NumberBoxIcon() {
	return colorizeIcon( <SVGNumberBoxIcon width="20" height="20" /> )
}

export function PaginationIcon() {
	return colorizeIcon( <SVGPaginationIcon width="16" height="16" /> )
}

export function PricingBoxIcon() {
	return colorizeIcon( <SVGPricingBoxIcon width="20" height="20" /> )
}

export function SeparatorIcon() {
	return colorizeIcon( <SVGSeparatorIcon width="20" height="20" /> )
}

export function SocialButtonsIcon() {
	return colorizeIcon( <SVGSocialButtonsIcon width="16" height="16" /> )
}

export function SpacerIcon() {
	return colorizeIcon( <SVGSpacerIcon width="20" height="20" /> )
}

export function TeamMemberIcon() {
	return colorizeIcon( <SVGTeamMemberIcon width="20" height="20" /> )
}

export function TestimonialIcon() {
	return colorizeIcon( <SVGTestimonialIcon width="20" height="20" /> )
}

export function TextIcon() {
	return colorizeIcon( <SVGTextIcon width="20" height="20" /> )
}

export function VideoPopupIcon() {
	return colorizeIcon( <SVGVideoPopupIcon width="20" height="20" /> )
}

export function UngroupContainerIcon() {
	return colorizeIcon( <SVGUngroupContainerIcon width="20" height="20" className="components-menu-items__item-icon" /> )
}

export function GhostButtonIcon() {
	return <ButtonIcon />
}
